/**
 * Client Component에서도 안전하게 사용할 수 있는 compile-time public env.
 * 공개 origin 검증은 Zod가 client bundle로 유입되지 않도록 env.server.ts에서 수행한다.
 */
export const isDev = process.env.NODE_ENV === 'development'
export const isProd = process.env.NODE_ENV === 'production'
export const isTest = process.env.NODE_ENV === 'test'

export const webVitalsEndpoint = parseOptionalSameOriginPath(
  process.env.NEXT_PUBLIC_WEB_VITALS_ENDPOINT,
  'NEXT_PUBLIC_WEB_VITALS_ENDPOINT'
)

export function parseOptionalSameOriginPath(
  value: string | undefined,
  name: string
): string | undefined {
  const candidate = value?.trim()
  if (!candidate) {
    return undefined
  }

  const baseUrl = 'https://app.local'
  let parsedUrl: URL
  try {
    parsedUrl = new URL(candidate, baseUrl)
  } catch {
    throw new Error(`${name}에는 hash가 없는 same-origin 경로를 입력해 주세요.`)
  }

  if (
    !candidate.startsWith('/') ||
    candidate.startsWith('//') ||
    parsedUrl.origin !== baseUrl ||
    parsedUrl.hash
  ) {
    throw new Error(`${name}에는 hash가 없는 same-origin 경로를 입력해 주세요.`)
  }

  return `${parsedUrl.pathname}${parsedUrl.search}`
}
